import { Box, colors, Typography } from "@mui/material";
import HtmlContent from "components/HtmlContent";
import { OrderComment } from "models/OrderComment";

type WorkDescriptionCommentProps = { comment: OrderComment };

const WorkDescriptionComment: React.FC<WorkDescriptionCommentProps> = ({ comment }) => {
  return (
    <Box sx={{ bgcolor: colors.grey[200], p: 2, borderRadius: 4 }}>
      <HtmlContent html={comment.text} />
    </Box>
  );
};

export default WorkDescriptionComment;
